export const SET_ACTIVITY_RANGE_HOURS = 'SET_ACTIVITY_RANGE_HOURS';
